import { Component, Input } from '@angular/core';
import { Task } from '../../models/task.model';
import { EstimationWarningsService } from '../../services/estimation-warnings.service';
import { EstimationSourceSubtype } from '../../models/estimation-v3.types';

/**
 * Badge enriquecido v3 para una tarea: origen (IA/Histórica/Manual/...),
 * subtipo de origen, icono "fantasma" para execution_only y tooltip con
 * factores aplicados (calibración, IA, freshness, análogos).
 *
 * Reutiliza la clase global `.badge` con `[data-source]`. Si la tarea no
 * tiene campos v3, sigue mostrando solo el origen como antes.
 */
@Component({
  selector: 'app-task-source-badge',
  templateUrl: './task-source-badge.component.html',
  styleUrls: ['./task-source-badge.component.scss']
})
export class TaskSourceBadgeComponent {
  @Input() task!: Task;

  /** Opacidad para modo diff "removed". */
  @Input() opacity: number = 1;

  constructor(private warningsService: EstimationWarningsService) {}

  get source(): string {
    return this.task?.source ?? '';
  }

  get subtype(): EstimationSourceSubtype | undefined {
    return this.task?.source_subtype;
  }

  get subtypeLabel(): string {
    return this.warningsService.getSourceSubtypeLabel(this.subtype);
  }

  get isPhantom(): boolean {
    return this.subtype === 'execution_only';
  }

  get factorsTooltip(): string {
    return this.warningsService.formatTaskFactorsTooltip(this.task);
  }

  /** True si la tarea tiene cualquier dato v3 enriquecido para mostrar. */
  get hasV3Data(): boolean {
    return !!(this.subtype || this.factorsTooltip);
  }
}
